module.exports = __webpack_public_path__ + "static/media/sayali_patil.e347360a.jpg";